import { render, staticRenderFns } from "./Weekday.vue?vue&type=template&id=495118e8&scoped=true"
import script from "./Weekday.vue?vue&type=script&lang=js"
export * from "./Weekday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495118e8",
  null
  
)

export default component.exports